import { useState } from 'react';
import { useLocation } from 'react-router';
import { useDocumentTitle } from '../../shared/hooks';
import { t } from '../../shared/messages/vi';
import { useAuth } from '../../shared/providers';
import { getAppProgress } from '../history/sync';
import { getHomeClassStore } from './class-store';
import { HomeScreen } from './home-screen';
import { loadLatestAttemptApi } from './latest-attempt';
import { localDateISO } from './regulation';

/** Router state set by the account deletion (features/auth/account `HOME_ACCOUNT_DELETED_STATE`). */
const isAccountDeleted = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as { accountDeleted?: unknown }).accountDeleted === true;

/** `/`: the home screen wired to the session, the app-wide progress repo and the browser storage. */
export function HomePage() {
  const location = useLocation();
  const { status, user } = useAuth();
  // The app-wide switchable repo: local for a guest, synced once signed in (as on /ly-thuyet).
  const [progress] = useState(getAppProgress);
  const [today] = useState(() => localDateISO(new Date()));
  useDocumentTitle(t('home.title'));

  return (
    <HomeScreen
      authStatus={status}
      userId={status === 'authenticated' ? (user?.id ?? null) : null}
      classStore={getHomeClassStore()}
      progressRepo={progress.repo}
      loadApi={loadLatestAttemptApi}
      today={today}
      title={t('home.title')}
      notice={isAccountDeleted(location.state) ? <p role="status">{t('account.deleted')}</p> : null}
    />
  );
}
